import type {
	BulkToggleWorkspaceRadioChannelsRequest,
	BulkToggleWorkspaceRadioChannelsResponse,
	CreateWorkspaceRadioChannelResponse,
} from "@somewear/api";
import { grpc, someGrpc } from "@somewear/grpc";
import type { ActionSetEpic } from "@somewear/model";
import { createActionSetEpicHandler } from "@somewear/model";
import { WorkspaceRadioChannelRequest } from "@somewear/radio";
import { combineEpics } from "redux-observable";

import { workspaceRadioChannelActions } from "./workspace.radio.actions";

const createWorkspaceRadioChannelEpic: ActionSetEpic<
	WorkspaceRadioChannelRequest,
	CreateWorkspaceRadioChannelResponse.AsObject
> = (action$, state$) => {
	return createActionSetEpicHandler(
		action$,
		state$,
		workspaceRadioChannelActions.createWorkspaceRadioChannel,
		(request) =>
			grpc.prepareRequestWithPayload(someGrpc.createWorkspaceRadioChannel, request.data),
	);
};

const toggleWorkspaceRadioChannelEpic: ActionSetEpic<
	BulkToggleWorkspaceRadioChannelsRequest.AsObject,
	BulkToggleWorkspaceRadioChannelsResponse.AsObject
> = (action$, state$) => {
	return createActionSetEpicHandler(
		action$,
		state$,
		workspaceRadioChannelActions.bulkToggleWorkspaceRadioChannels,
		(request) =>
			grpc.prepareRequestWithPayload(someGrpc.bulkToggleWorkspaceRadioChannels, request.data),
	);
};

export const workspaceRadioChannelEpics = combineEpics<any, any, any>(
	createWorkspaceRadioChannelEpic,
	toggleWorkspaceRadioChannelEpic,
);
